import { render, staticRenderFns } from "./modeloForm.vue?vue&type=template&id=4630cdba&"
import script from "./modeloForm.vue?vue&type=script&lang=js&"
export * from "./modeloForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports